import React from 'react';

export default function Image({ image }) {
  return image ? <img width='200' src={image.url} /> : "Select Image";
}
